import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaFilePdf } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import ButtonWrapper from "../../components/Button";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";

const Step7 = ({ formData, id, handleTabChange, isEmployee }) => {
  const { t } = useTranslation();
  console.log("formDataInStep7", formData);
  const formType = "MAP_SUB";
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployeeData = history.location.pathname.includes("employee");
  const mapSanctionData = Digit.SessionStorage.get("MAP_SANCTION_DETAIL") || {};
  const userType = Digit.SessionStorage.get("userType");

  const dwgPdf =
    (formData &&
      formData?.documents &&
      formData?.documents?.length > 0 &&
      formData?.documents?.find((item) => item?.documentType === "drawingPdf")?.fileStoreId) ||
    null;
  const appPdf =
    (formData &&
      formData?.documents &&
      formData?.documents?.length > 0 &&
      formData?.documents?.find((item) => item?.documentType === "approvalLetter")?.fileStoreId) ||
    null;

  console.log("DWASAHS", appPdf, dwgPdf);

  const { data = {}, isLoading, refetch } = Digit.Hooks.obps.useBPADetailsPage(
    stateId,
    { applicationNo: id, isEmployee: isEmployeeData },
    { formType, config: { staleTime: 0, cacheTime: 0, refetchOnMount: true, refetchOnWindowFocus: false, refetchOnReconnect: true } }
  );
  useEffect(() => {
    if (id && formType) {
      refetch();
    }
  }, [id, formType, refetch]);
  const extractData = data?.BPA?.[0] || {};
  console.log("api-response", data, extractData);
  return (
    <div>
      {/* sanction-map */}

      <div className="formContainer">
        <div className="formHeaderContainer">
          <h2 className="formHeading" style={{ marginBottom: 10 }}>
            {t("Document")}
          </h2>
        </div>
        <Container fluid className="formInputContainer common-app-form">
          <Row>
            <Col>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={6}>
                  <strong>Drawing PDF</strong>:
                </Grid>{" "}
                {/* Label part */}
                <Grid item xs={6}>
                  {formData?.selfDrawingPdfUrl || extractData?.selfDrawingPdfUrl || dwgPdf ? (
                    <FaFilePdf
                      color="#a10505"
                      style={{ width: "20px", height: "30px", cursor: "pointer" }}
                      onClick={() => {
                        dwgPdf
                          ? getDocumentByFileStoreId(dwgPdf, setIsPreviewLoading)
                          : window.open(formData?.selfDrawingPdfUrl || extractData?.selfDrawingPdfUrl, "_blank");
                      }}
                    />
                  ) : (
                    <FaFilePdf color="#00000057" style={{ width: "20px", height: "30px" }} />
                  )}
                </Grid>
              </Grid>
            </Col>
            <Col>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={6}>
                  <strong>Approval Letter</strong>:
                </Grid>{" "}
                {/* Label part */}
                <Grid item xs={6}>
                  {formData?.approvalCertificateUrl || extractData?.approvalCertificateUrl || appPdf ? (
                    <FaFilePdf
                      color="#a10505"
                      style={{ width: "20px", height: "30px", cursor: "pointer" }}
                      onClick={() => {
                        appPdf
                          ? getDocumentByFileStoreId(appPdf, setIsPreviewLoading)
                          : window.open(formData?.approvalCertificateUrl || extractData?.approvalCertificateUrl, "_blank");
                      }}
                    />
                  ) : (
                    <FaFilePdf color="#00000057" style={{ width: "20px", height: "30px" }} />
                  )}
                </Grid>
              </Grid>
            </Col>
          </Row>
        </Container>
        {userType !== "employee" && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleTabChange(2)}
              />
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Next"
                onClick={() => handleTabChange(4)}
                sx={{ backgroundColor: "#157CB3" }}
              />
            </div>
          </div>
        )}
      </div>

      {/* sanction-map */}
    </div>
  );
};

export default Step7;
